module.exports = {
  server_url: 'https://dietly.pl',
};
